<template>
  <div id="app">
    <header v-if="headerShow">
      <div class="header">
        <router-link to="/"><h1 class="left r2logo"></h1></router-link>
        <ul class="left">
          <li @click="navClick(1)" v-bind:class="{current:1==currentNum}"><router-link to="/">首页</router-link></li>
          <!--<li @click="navClick(2)" v-bind:class="{current:2==currentNum}"><router-link to="/game">充值</router-link></li>-->
          <li><a href="//www.r2game.com/">海外平台</a></li>
          <li><a href="//corporate.r2games.com/?ac=contact">客服服务</a></li>
          <li class="ewmShow"><a>关注微信</a><div class="ewm"></div></li>
        </ul>
        <div class="r2list right">
          <div class="r2list-button">
            <i class="icon-mgame"></i><span>魔力游戏</span>
          </div>
          <div class="top-gameBox cd">

            <!-- <a href="" class="top-ad" target="_blank" v-html="headimg"></a> -->
            <p class="top-ad"></p>
            <div class="top-lst">
              <div class="m-topGame">
                <h2 class="title web-title">手机游戏</h2>
                <ul class="u-gameLst cd">
                  <li v-for="(i,index) in list" :key="index">
                    <a target="_blank" v-if="i.url" :href="i.url">
                      <span>{{i.title}}</span>
                      <i class="icon" :class="{'hot':i.type2==1,'new':i.type2==2}"></i>
                    </a>
                    <a target="_blank"  v-if="!i.url" @click="onMassageChange('敬请期待')">
                      <span>{{i.title}}</span>
                      <i class="icon" :class="{'hot':i.type2==1,'new':i.type2==2}"></i>
                    </a>
                  </li>
                </ul>
              </div>
              <!--<a href="" class="o-btnBig u-topBtn">查看更多</a>-->
            </div>
          </div>
        </div>
        <div class="header-login" id="toploginForm">
          <router-link v-if="isLogin" class="login" to="/personage">{{isLogin}}</router-link>
          <a v-if="!isLogin" title="登录" v-on:click="popUpWindow('登录')">登录</a> |
          <a title="注册" v-on:click="popUpWindow('快速注册')" v-if="!isLogin">注册</a>
          <a title="注销" v-on:click="logout()"  v-if="isLogin">注销</a>
        </div>

      </div>
    </header>
    <router-view></router-view>
    <Vfooter v-if="currentNum!=1"></Vfooter>
    <Vjoin :webpopUp="popUp" @on-popUp-change="onPopUpChange"></Vjoin>
    <Vagreement :agreement="agreementnew" @on-agreement-change="onAgreementChange"></Vagreement>
    <!--<Valert></Valert>-->
  </div>
</template>

<script>
  import Vue from 'vue';
  import VueResource from 'vue-resource';
  import Vjoin from './components/component/join.vue'
  import Valert from './components/component/alert.vue'
  import Vfooter from './components/component/footer.vue'
  import Vagreement from './components/component/agreement.vue'
  Vue.use(VueResource);
  export default {
    name: 'app',
    components:{
      Vjoin,Valert,Vagreement,Vfooter
    },
    data () {
      return {
        agreementnew:"",
        currentNum: 1,
        isLogin:false,
        popUp:'',
        path:'',
        list:'',
        headimg:'',
        headerShow: false
      }
    },
    watch:{
      '$route' (to, from) {
        //不需要官网header
        this.$route.name !== undefined? this.$route.name +new Date(): this.$route +new Date()
        if((/\/customer/g.test(this.$route.path)) || (/\/forum/g.test(this.$route.path))){
          this.headerShow = false
        }else{
          this.headerShow = true
        }

        if((/\/game/.test(this.$route.path))&&!(/\/game.+/.test(this.$route.path))){
          this.currentNum=2
        }else if(/\/recharge/.test(this.$route.path)){
          this.currentNum=3
        }else {
          this.currentNum=1
        }
      }
    },
    created:function () {
      //不需要官网header
      if((/\/customer/g.test(this.$route.path)) || (/\/forum/g.test(this.$route.path))){
        this.headerShow = false
      }

      var name = 'userName='
      var ca = document.cookie.split(';');
      for(var i=0; i<ca.length; i++)
      {
        var c = ca[i].trim();
        if (c.indexOf(name)==0)
            this.isLogin = c.split('=')[1]
      }
      if((/\/game/.test(this.$route.path))&&!(/\/game.+/.test(this.$route.path))){
        this.currentNum=2
      }else if(/\/recharge/.test(this.$route.path)){
        this.currentNum=3
      }else {
        this.currentNum=1
      }

      this.$http.get(weUrl+'headimg/index.html')
        .then(function(data){
         this.headimg=data.body
        },function(response){

        })
      this.$http.get(weUrl+'list/index.html')
        .then(function(data){
          var basic = data.bodyText.substring(0, data.bodyText.lastIndexOf(','))+']';
          this.list=JSON.parse(basic)
        },function(response){

        })
    },
    methods:{
      onAgreementChange:function (val) {
        this.agreementnew=val
      },
      onMassageChange:function (val) {
        this.massagenew=val
      },
      onPopUpChange:function (val) {    //接受弹窗传值
        this.popUp=val
      },
      logout:function(){               //注销
        document.cookie="userName=John Doe; expires=Thu, 18 Dec 2013 12:00:00 GMT";

        this.isLogin = ''
        this.$router.push({path:'/'})
        window.location = 'http://www.r2games.com.cn/?ct=user&ac=logout'
      },
      popUpWindow:function (a) {        //弹窗
        this.popUp=a
      },
      navClick: function (a) {            //nav选择
        this.currentNum = a
      }
    }
  }
</script>

<style lang="stylus">
  @import "../static/css/reset.css";

  header
    height 73px
    box-shadow 0 0 7px rgba(0,0,0,0.3)
    .header
      height 73px
      /*overflow hidden*/
      position relative
      .r2logo
        height 68px
        width 170px
        background-image url("../static/img/logo.png")  
        background-repeat no-repeat
        background-position 0 -48px
      >ul
        margin-left 132px
        .current
          &::after
            width 100%
          a
            color #de4205
        .ewmShow
          .ewm
            display none
            z-index 2
            width 133px
            height 133px
            position absolute
            left 0px
            background url("../static/img/QRcode.jpg")
          &:hover .ewm
            display block
        li
          position relative
          text-align center
          padding 0 28px
          height 73px
          line-height 73px
          float: left  
          cursor pointer
          &::after
            content ''
            display block
            height 2px
            background #de4205
            position absolute
            bottom 0
            width 0
            left 0px
            transition .5s all
          &:hover::after
            width 100%
          &:hover a{
            color #de4205
          }
          a
            width 100%
            height 100%
            color #000
            display block
            font-size 18px
      .header-login
        float right
        color #808080
        line-height 70px
        .login
          color #de4205
        a
          font-size 14px
          color #808080
          padding 0 5px
          cursor pointer
          &:hover
            color #de4205
      .r2list
        /*position relative*/
        margin-top 22px
        .r2list-button
          width 103px
          height 28px
          line-height 28px
          font-size 14px
          box-sizing border-box
          border 1px solid #dbdbdb
          margin-left 25px
          cursor pointer
        &:hover
          padding-bottom 23px
        &:hover .r2list-button
          background linear-gradient(#fff,#f1f1f1)
          color #e36445
        &:hover .top-gameBox
          display block
          background #fff
          position absolute
          top 73px
          width 1200px
          right 0
          z-index 51
          height 289px
        &:hover .r2list-button >i
          background-position -102px -116px
        i
          float left
          width 6px
          height 8px
          margin  10px 7px 0 15px
          background url("../static/img/icon.png")no-repeat -63px -116px;
        .top-gameBox
          display block
          background #fff
          position absolute
          top 73px
          width 1200px
          right 0
          z-index 51
          height 0px
          transition all .5s
          overflow hidden
          .top-ad
            width 490px
            height 289px
            float left
            overflow hidden
          .top-lst
            width:654px;
            float:left;
            border-left:1px solid #e9e9e9;
            .m-topGame
              width:654px;
              float:left;
              margin:14px 17px 0 25px;
              height:372px;
              .title
                color #de4205
                font:bold 16px/35px "Microsoft Yahei",Arial;
                border-bottom:2px solid #de4205;
              .u-gameLst
                padding-top:17px;
                font-size:13px;
                li
                  float:left;
                  width:25%;
                  line-height 25px
                  a
                    margin-bottom:5px;
                    color:#505050;
                    display:block;
                    clear:both;
                    height:25px
                    i
                      display:inline-block;width:16px;height:12px;margin-left:10px;
                      background-position:-1000px -1000px;
                    .new
                      background-position:-69px -114px;
                    .hot
                      background-position:-85px -114px;
                    &:hover
                      color:#de4205


  .black-bg
    height 100%
    width 100%
    position fixed
    background rgba(0,0,0,.5)
    top 0
    left 0
    z-index 100
    >div
      margin 100px auto
      width 408px
      background #de3f05
      border-radius 5px 5px 0 0
      h5
        height 50px
        background url("../static/img/myicon.png") no-repeat 26px 0px
        font-size 24px
        line-height 60px
        text-align center
        font-weight normal
        color #fff
        position relative
        padding-bottom 0
        div
          cursor pointer
          position absolute
          right 0
          top 0
          font-size 28px
          line-height 28px
          margin-right 22px
          margin-top 9px
      >div
        background #ffffff
        padding 20px 43px
        .logo
          width 130px
          height  37px
          background url("../static/img/icon.png")
          background-size 150px auto
          margin 0 auto 20px
        .username
          position relative
          .icon-log
            width 20px
            height 20px
            position absolute
            left 10px
            top 10px
            background-position: -55px -132px;
          input
            background #f5f5f5
            height 36px
            border 1px solid #c5c4c4
            padding 0 30px
            width 260px
            border-radius 4px
            font-size 14px
            line-height 36px
            margin-bottom 5px
          p
            font-size 12px
            line-height 12px
            color  #de4205
            .icon-exclamation
              width 16px
              height 16px
              float left
              background-position 0 -133px
        .password
          padding-top 10px
          position relative
          .icon-password
            width 20px
            height 20px
            position absolute
            left 10px
            top 20px
            background-position: -81px -132px;
          input
            background #f5f5f5
            height 36px
            border 1px solid #c5c4c4
            padding 0 30px
            width 260px
            border-radius 4px
            font-size 14px
            line-height 36px
            margin-bottom 5px
          p
            font-size 12px
            line-height 12px
            color  #de4205
            .icon-exclamation
              width 16px
              height 16px
              float left
              background-position 0 -133px
        .orther
          padding-top 10px
          padding-bottom 15px
          color #605f67
          font-size 14px
          line-height 16px
          a
            float right
        button
          width 100%
          height 42px
          line-height 42px
          background #9dd429
          color #fff
          font-size 18px
          border none
          border-radius 3px
          text-align center
        .register
          color #605f67
          margin-top 14px
          line-height 21px
          text-align center
          a
            color #de4205
            cursor pointer
        .ortherLogo
          color #605f67
          margin-top 14px
          line-height 24px
          text-align center
          .icon
            width: 26px;
            height: 26px;
            display: inline-block;
            vertical-align: middle;
            margin 0 2px
          .icon-xr
            background-position 0 -101px
          .icon-wx
            background-position -31px -101px
          .icon-qq
            background-position -62px -101px
          .icon-tx
            background-position -93px -101px
        ul
          width 308px
          margin 14px auto 10px
          display block
          overflow hidden
          li
            color: #a3a3a3;
            float: left;
            border-bottom: 2px solid #bebebe;
            width: 154px;
            text-align: center;
            font-size: 16px;
            line-height: 38px;
            cursor: pointer;
          .current
            color: #de4205;
            border-bottom: 2px solid #de4205;
        .register-content
          input
            width: 286px;
            padding: 0 10px;
            border: 1px solid #b6b6b6;
            height: 30px;
            line-height: 30px;
            outline: 0;
            border-radius: 3px;
            background: #fff;
            margin-bottom 5px
            margin-top 10px
          .error
            font-size 12px
            line-height 12px
            color  #de4205
            .icon-exclamation
              width 16px
              height 16px
              float left
              background-position 0 -133px
          .istrue
            color #aeaeae
          .getMessage
            padding-top 10px
            padding-bottom 5px
            width 308px
            overflow hidden
            input
              margin 0
              width 155px
              float left
            .getMessageBtb
              float right
              height: 30px;
              line-height: 28px;
              border: 1px solid #f18f00;
              cursor: pointer;
              text-align: center;
              color: #f18f00;
              font-size: 14px;
              border-radius: 3px;
              display: inline-block;
              background: #fff;
              width: 117px;
            .getMessageBtbNo
              float right
              height: 30px;
              line-height: 28px;
              border: 1px solid #ccc;
              cursor: pointer;
              text-align: center;
              color: #ccc;
              font-size: 14px;
              border-radius: 3px;
              display: inline-block;
              background: #fff;
              width: 117px;
          .verification
            line-height 0
            overflow hidden
            padding-top 10px
            width 308px
            padding-bottom 5px
            input
              height 32px
              width 125px
              float left
              margin 0
              margin-right 10px
            img
              width 117px
              height 30px
              float left
              cursor pointer
            .icon-re
              cursor pointer
              width  23px
              float left
              height 20px
              margin-top 6px
              background-position: -106px -132px;
          .agreement
            padding-top 10px
            width  308px
            .check
              margin: 3px 3px 3px 4px;
              width 13px
              height 13px
            a
              color #605f67
              cursor pointer

</style>



// WEBPACK FOOTER //
// App.vue?7675ffbe